export const TRIGGERS = ['showAfterDelay', 'showOnPageScroll', 'showOnExitIntent', 'showAfterInactivity'];
export const TRIGGER_VALUE_FIELDS = {
  showOnPageScroll: 'pageScrollPercentageTrigger',
  showAfterDelay: 'delayInSeconds',
  showAfterInactivity: 'inactivityInSeconds'
};
export const WEBSITE_FILTER_TYPES = ['URL', 'QUERY_PARAM'];
export const SAVED_AUDIENCE_FILTER_TYPE = 'SAVED_AUDIENCE';